import { Layout } from "@/components/layout/Layout";
import { AnimatedSection, AnimatedHeading } from "@/components/ui/AnimatedSection";
import { SEO } from "@/components/SEO";

export default function Barrierefreiheit() {
  return (
    <Layout>
      <SEO title="Barrierefreiheit | REWE V. Gahndi" description="Erklärung zur Barrierefreiheit der Website von REWE V. Gahndi." path="/barrierefreiheit" />
      <section className="section-padding">
        <div className="container-custom max-w-4xl">
          <AnimatedHeading as="h1">
            <span className="text-gold-gradient">Barrierefreiheitserklärung</span>
          </AnimatedHeading>
          <AnimatedSection>
            <div className="space-y-8 text-center lg:text-left">
              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">Stand der Barrierefreiheit</h2>
                <p className="text-muted-foreground">Wir sind bestrebt, unsere Website barrierefrei zu gestalten. Diese Website ist weitgehend mit WCAG 2.1 Level AA konform. Wir arbeiten kontinuierlich an Verbesserungen.</p>
              </div>
              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">Unsere Maßnahmen</h2>
                <ul className="text-muted-foreground list-disc list-inside space-y-2">
                  <li>Ausreichende Farbkontraste für gute Lesbarkeit</li>
                  <li>Alternative Texte für Bilder</li>
                  <li>Tastaturnavigation möglich</li>
                  <li>Klare Fokus-States für interaktive Elemente</li>
                  <li>Semantisches HTML für Screenreader</li>
                </ul>
              </div>
              <div className="card-premium">
                <h2 className="text-xl font-heading font-semibold text-primary mb-4">Feedback & Kontakt</h2>
                <p className="text-muted-foreground">Falls du auf Barrieren stößt, kontaktiere uns: vigheshan.gahndi@rewe-kaufleute.com oder 06145 321455.</p>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </Layout>
  );
}
